import React, { useState, useEffect } from "react";
import { Link } from 'react-router-dom';
import axios from 'axios';
import { API_URL } from '../../global/components/Constants';
import {useDispatch, useSelector} from 'react-redux';
import { topicData, setTopic, setTopicComponents } from '../../slices/topicSlice';
import { genNextId, sortById } from '../../utils/globalUtils';
import { tableInit } from "../../utils/topicComponent/tableUtils";
import { topicThemes, mPInit, previewInit } from '../../utils/topicUtils';
import { saveTopicComponent, getTopicComponents } from '../../utils/api-services/topic';
import MarginPaddingControl from './MarginPaddingControl';

const EditorTable = ({params}) => {

    const [formId, setFormId] = useState(0);
    const [title, setTitle] = useState("");
    const [theme, setTheme] = useState(topicThemes[0].Value);
    const [size, setSize] = useState("small"); 
    const [data, setData] = useState(tableInit);
    const [marginPadding, setMarginPadding] = useState(mPInit);
    const [applyBtnHover, setApplyBtnHover] = useState(false);
    const [cancelBtnHover, setCancelBtnHover] = useState(false);
    const [frmError, setFrmError] = useState("");
    const [posting, setPosting] = useState(false);

    const tpicData = useSelector(topicData);
    const dispatch = useDispatch();
    const topic = tpicData.topic;
    const topicComponents = tpicData.topicComponents;

    useEffect(()=>{
        presetForm();
    }, []);
    
    function presetForm(){
        const obj = params.obj;
        if(obj != null){
            setFormId(obj.Id);
            const content = JSON.parse(obj.Content);
            const tbTitle = content.Title;
            const theme = content.Theme;
            const size = content.Size;
            const tbData = content.Data;

            let clonedData = [...data];
            for(let i=0; i<tbData.length; ++i){
                const rec = tbData[i];
                clonedData[rec.RowIndex][rec.ColIndex] = {val: rec.CellValue};
            }

            setTitle(tbTitle);
            setTheme(theme);
            setSize(size);
            setData(clonedData);
            setMarginPadding(content.MarginPadding);
        }else{
            clareData();
        }
    }

    const handleCellChange = (rowIndex, colIndex, value) => {
        const clonedData = [...data];
        clonedData[rowIndex][colIndex] = {val: value}
        setData(clonedData);
    };

    const handleApplyBtnHover = (status) => {
        setApplyBtnHover(status);
    }

    const handleCancelBtnHover = (status) => {
        setCancelBtnHover(status);
    }

    const apply = async () => {

        setFrmError("");

        let tableData = [];

        for(let i=0; i<data.length; ++i){
            for(let j=0; j<data[i].length; ++j){
                if(data[i][j].val != null && data[i][j].val != undefined && data[i][j].val != ""){
                    tableData.push({
                        CellValue: data[i][j].val,
                        RowIndex: i,
                        ColIndex: j
                    })
                }
            }
        }

        if(tableData.length == 0){
            setFrmError("Please enter data");
            return;
        }

        let dataToSave = {
            Title: title, 
            Theme: theme, 
            Size: size,
            Data: tableData,
            MarginPadding: marginPadding
        };
        
        const saveRecord = await saveTopicComponent({
            id: formId,
            topicSlug: topic.Slug,
            componentType: params.componentType,
            containerId: params.containerId,
            content: JSON.stringify(dataToSave),
            editor: params.editor,
            rank: 0,
            photo: ""
        });
                
        if(saveRecord.Success){
            loadTopicComponents();
        }
                
        params.close();
    };

    const loadTopicComponents = async () => {
        const data = await getTopicComponents(topic.Slug);
        dispatch(setTopicComponents(data));
    }

    function cancel(){
        clareData();
        close()
    }

    function clareData(){

        setMarginPadding({
            Margin: {
                Top: 0,
                Right: 0,
                Bottom: 0,
                Left: 0
            },
            Padding: {
                Top: 10,
                Right: 10,
                Bottom: 10,
                Left: 10
            }}
        )

        const clonedData = [...data];
        for(let i=0; i<clonedData.length; ++i){
            for(let j=0; j<clonedData[i].length; ++j){
                if(i==0 && j<2){
                    clonedData[i][j] = {val: `Title ${j + 1}`};
                }else if((i > 0 && i < 3) && j<2){
                    clonedData[i][j] = {val: `Value`};
                }else{
                    clonedData[i][j] = {val: ""};
                }
            }
        }
        setData(clonedData);
    }

    function darkenHex(hex, percent) {
        // Remove "#" if present
        hex = hex.replace(/^#/, '');
    
        // Convert to RGB
        let r = parseInt(hex.substring(0, 2), 16);
        let g = parseInt(hex.substring(2, 4), 16);
        let b = parseInt(hex.substring(4, 6), 16);
    
        // Darken each channel
        r = Math.max(0, Math.floor(r * (1 - percent / 100)));
        g = Math.max(0, Math.floor(g * (1 - percent / 100)));
        b = Math.max(0, Math.floor(b * (1 - percent / 100)));
    
        // Convert back to hex
        let darkHex = `#${r.toString(16).padStart(2, '0')}${g.toString(16).padStart(2, '0')}${b.toString(16).padStart(2, '0')}`;
    
        return darkHex;
    }

    const mp = marginPadding;

    const colors = theme.split("-");
    const bgColor = colors[0];
    const txtColor = colors[1];
    const extra1 = colors[2];
    const extra2 = colors[3];
    const extra3 = colors[4];

    let titleSz = 0; let textSz = 0;
    if(size == "small"){ titleSz=20; textSz=16 }
    else if(size == "medium"){ titleSz=24; textSz=18 }
    else if(size == "large"){ titleSz=34; textSz=24 }

    const styles = {
        form:{
            
        },
        label:{
            color: "#aaa",
            fontSize: 14,
            fontWeight: 500
        },
        labelSm:{
            color: "#999",
            fontSize: 12,
            fontWeight: 500
        },
        body:{
            marginBottom:30,
            padding: '10px 20px',
        },
        gridWrap:{
            maxHeight: 400,
            overflow: 'scroll'
        },
        grid:{
            borderColor: '#ddd',
            borderCollapse: 'collapse',
        },
        gridHead:{
            background: (bgColor == "#fff")? "#8e8e8e": darkenHex(bgColor, 50),
            color: "#fff",
            minWidth: 160,
            minHeight: 25,
            borderRadius: 0,
            border: 'none',
            outline: 'none',
            boxShadow: 'none',
            transition: 'none',
            fontWeight: 700,
            paddingTop: parseInt(mp.Padding.Top),
            paddingRight: parseInt(mp.Padding.Right),
            paddingBottom: parseInt(mp.Padding.Bottom),
            paddingLeft: parseInt(mp.Padding.Left),
            fontSize: textSz
        },
        gridData:{
            background: bgColor,
            color: txtColor,
            minWidth: 160,
            minHeight: 25,
            borderRadius: 0,
            border: 'none',
            outline: 'none',
            boxShadow: 'none',
            transition: 'none',
            paddingTop: parseInt(mp.Padding.Top),
            paddingRight: parseInt(mp.Padding.Right),
            paddingBottom: parseInt(mp.Padding.Bottom),
            paddingLeft: parseInt(mp.Padding.Left),
            fontSize: textSz
        },
        info:{
            color: "#666",
            marginBottom: 10,
            fontSize: 14,
        },
        titleInput:{
            fontWeight: 600,
            outline: 'none',
            boxShadow: 'none',
            transition: 'none',
        },
        footer:{
            padding: '20px 20px',
            borderTop: '1px solid #ccc'
        },
        btns:{
            display: 'flex',
        },
        cancelBtn:{
            background: cancelBtnHover? '#666': '#fff',
            color: cancelBtnHover? '#fff': '#333',
            border: '1px solid #bbb',
            fontSize: 14
        },
        applyBtn:{
            background: applyBtnHover? '#666': '#888',
            color: "#fff",
            marginLeft: 'auto',
            fontSize: 14,
            justifyContent: 'flex-end'
        },
        frmError:{
            color: '#990000',
            marginTop: 15,
            marginBottom: 30,
            fontSize: 14
        }
    }

    return (
        <div style={styles.form}>

            <div style={styles.body}>

                <div className='row'>
                    <div className='col-6 col-md-9 form-group'>
                    <label style={styles.labelSm}>TITLE</label>
                        <input type='text' value={title} onChange={e => setTitle(e.target.value)} style={styles.titleInput} className="form-control form-control-sm" placeholder='Enter title (optional)' />                
                    </div>
                    <div className="col-6 col-md-3 form-group">
                        <label style={styles.labelSm}>THEME</label>
                        <select value={theme} onChange={e => setTheme(e.target.value)} className="form-control form-control-sm">
                            {topicThemes.map(itm=>(
                                <option key={itm.Id} value={itm.Value}>{itm.Name}</option>
                            ))}
                        </select>
                    </div>
                    <div className="col-6 col-md-3 form-group">
                        <label style={styles.labelSm}>SIZE</label>
                        <select value={size} onChange={e => setSize(e.target.value)} className="form-control form-control-sm">
                            <option key={1} value={"small"}>Small</option>
                            <option key={2} value={"medium"}>Medium</option>
                            <option key={3} value={"large"}>Large</option>
                        </select>
                    </div>
                    <div className="col-12 col-md-9 form-group">
                        <MarginPaddingControl 
                            marginPadding={marginPadding} 
                            setMarginPadding={setMarginPadding} 
                            inline={true}
                        />
                    </div>
                </div>

                <div style={styles.info}>Enter your data in the grid (Use first row as heading)</div>

                <div style={styles.gridWrap}>
                <table border="1" style={styles.grid}>
                    <tbody>
                    {data.map((row, rowIndex) => (
                        <tr key={rowIndex}>
                        {row.map((cell, colIndex) => (
                            <td key={colIndex}>
                            <input
                                type="text"
                                value={cell.val}
                                onChange={(e) => handleCellChange(rowIndex, colIndex, e.target.value)}
                                style={rowIndex==0? styles.gridHead: styles.gridData}
                                className="form-control form-control-sm"
                            />
                            </td>
                        ))}
                        </tr>
                    ))}
                    </tbody>
                </table>
                </div>

            </div>
            <div style={styles.footer}>
                
                {frmError != "" && <div style={styles.frmError}>{frmError}</div>}

                <div style={styles.btns}>
                    <Link onClick={()=>cancel()} style={styles.cancelBtn} className='btn' onMouseEnter={()=>handleCancelBtnHover(true)} onMouseLeave={()=>handleCancelBtnHover(false)}>CANCEL</Link>
                    <Link onClick={()=>apply()} style={styles.applyBtn} className='btn' onMouseEnter={()=>handleApplyBtnHover(true)} onMouseLeave={()=>handleApplyBtnHover(false)}>APPLY</Link>
                </div>
            </div>
        </div>
    );
    
};

export default EditorTable;
